<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div>
  <form
    #df="ngForm"
    novalidate
    (keydown.enter)="onSearchSourcedApplicationList()"
    class="formborder mb-4"
  >
    <div class="row m-0 col-md-12">
      <div class="col-md-2">
        <span class="required-lable"> From Date </span>

        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="FromDate"
            id="FromDate"
            #refFromDate="ngModel"
            (dateChange)="DateChange()"
            required
            class="form-control input-text-css"
            [(ngModel)]="FromDate"
            [ngClass]="{
              'is-invalid': df.submitted && refFromDate.invalid,
              'alert-warning':
                refFromDate.invalid &&
                (refFromDate.dirty ||
                  refFromDate.touched ||
                  refFromDate.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <span class="required-lable"> To Date </span>

        <div class="datepicker_feild">
          <input
            [matDatepicker]="picker2"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="ToDate"
            id="ToDate"
            #refToDate="ngModel"
            (dateChange)="DateChange()"
            required
            class="form-control input-text-css"
            [(ngModel)]="ToDate"
            [ngClass]="{
              'is-invalid': df.submitted && refToDate.invalid,
              'alert-warning':
                refToDate.invalid &&
                (refToDate.dirty || refToDate.touched || refToDate.untouched)
            }"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <span> Branch</span>
        <select
          name="SelectBranch"
          id="SelectBranch"
          #refSelectGender="ngModel"
          [(ngModel)]="SelectBranch"
          class="form-control input-text-css"
        >
          <option value="All">All</option>
          <option *ngFor="let branch of BranchesList" [value]="branch.BranchId">
            {{ branch.Branch_Name }}
          </option>
        </select>
      </div>

      <div class="col-md-2">
        <span> Product</span>
        <select
          name="ProductId"
          id="ProductId"
          #refProductId="ngModel"
          [(ngModel)]="ProductId"
          class="form-control input-text-css"
          [ngClass]="{
            'is-invalid': df.submitted && refProductId.invalid,
            'alert-warning':
              refProductId.invalid &&
              (refProductId.dirty ||
                refProductId.touched ||
                refProductId.untouched)
          }"
        >
          >
          <option value="All">All</option>
          <option
            *ngFor="let product of ProductList"
            [value]="product.ProductId"
          >
            {{ product.Product }}
          </option>
        </select>
      </div>

      <div class="col-md-1">
        <button
          type="button"
          (click)="onSearchSourcedApplicationList()"
          class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid"
        >
          Search
        </button>
      </div>
      <div class="col-md-3">
        <form action="" class="mt-3 search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
</div>
<div class="row m-0 mb-1">
  <div class="col-md-12">
    <div class="custom-tab-switcher d-flex">
      <div
        class="tab-item me-2"
        [ngClass]="{ active: tab === 'mytask' }"
        (click)="changeTab('mytask')"
      >
        Sourced During The Period
      </div>

      <div
        class="tab-item me-2"
        [ngClass]="{ active: tab === 'team' }"
        (click)="changeTab('team')"
      >
        Team View
      </div>

      <div
        class="tab-item"
        [ngClass]="{ active: tab === 'process' }"
        (click)="changeTab('process')"
      >
        Process View
      </div>
    </div>
  </div>
</div>
<div *ngIf="tab === 'mytask'">
  <div class="p-1">
    <div class="mt-3">
      <div class="">
        <div class="table-responsive table-striped" style="overflow: auto">
          <mat-table
            *ngIf="JsonData.length > 0"
            [dataSource]="DataSource"
            matSort
            matTableExporter
            #overallExporter="matTableExporter"
            class="table-bordered"
          >
            <ng-container matColumnDef="#">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                style="max-width: 50px"
                >#</mat-header-cell
              >
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell mw50"
              >
                {{
                  overallPaginator.pageIndex * overallPaginator.pageSize +
                    (i + 1)
                }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Application_No">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Application No
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                <app-main-card-info [loanId]="row.Loan_Id" [index]="i">
                  {{ row.Application_No }}
                </app-main-card-info>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LoanAcNo">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >LoanAcNo</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.LoanAcNo
              }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Customer_Name">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Customer Name</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Customer_Name
              }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="BranchName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >BranchName</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.BranchName
              }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="ProductName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Product</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.ProductName
              }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Sourced_On">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Sourced_On</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Sourced_On
              }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Sourced_By">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Sourced By</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Sourced_By
              }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Completed_ON">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Completed ON</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Completed_ON
              }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Current_Process">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Current_Process</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Current_Process
              }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="EmployeeName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >EmployeeName</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.EmployeeName
              }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Loan_Status">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Loan_Status</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Loan_Status
              }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="PendingSince">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >PendingSince</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.PendingSince
              }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Proposed_loanAmount">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Proposed_loanAmount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Proposed_loanAmount
              }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Approved_loanAmount">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Approved_loanAmount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.Approved_loanAmount
              }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="TAT">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >TAT</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                <i
                  (click)="GoToTATReportDetail(row)"
                  class="fa fa-stopwatch"
                  aria-hidden="true"
                ></i>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedOverallColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedOverallColumns"
            ></mat-row>
          </mat-table>

          <div class="row m-0 align-items-center">
            <div class="col-md-4">
              <button
                class="mt-3 btn font-size-12 button-btn"
                (click)="exportOverallTable()"
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Export
              </button>
            </div>
            <div class="col-md-8 mt-3">
              <mat-paginator
                #overallPaginator
                [pageSize]="20"
                showFirstLastButtons
                [pageSizeOptions]="[20, 50]"
              >
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-0 col-md-12 p-1" *ngIf="tab == 'process'">
  <div class="row m-0 col-md-12 p-0 mb-4">
    <div
      class="col-md-4 p-2"
      *ngFor="let item of processListData; let ind = index"
    >
      <div
        class="process-card shadow-sm"
        [ngClass]="{
          'active-card': selectedProcess?.ProcessID == item.ProcessID
        }"
        (click)="getDetail(item)"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="process-title">{{ item.ProcessName }}</span>
          <i
            class="fa fa-eye text-white"
            style="cursor: pointer; font-size: 20px"
          ></i>
        </div>
        <span class="process-count">{{ item.ApplicationCount }}</span>
      </div>
    </div>
  </div>
</div>

<div class="row m-0 col-md-12 p-1" *ngIf="tab == 'team'">
  <div class="row m-0 col-md-12 p-0 mb-4">
    <div
      class="col-md-4 p-2"
      *ngFor="let teamitem of teamListData; let ind = index"
    >
      <div
        class="team-card shadow-sm"
        [ngClass]="{
          'active-card': selectedTeam?.EmployeeID == teamitem.EmployeeID
        }"
        (click)="getTeamDetail(teamitem)"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="team-title">{{ teamitem.EmployeeName }}</span>
          <i
            class="fa fa-eye text-white"
            style="cursor: pointer; font-size: 20px"
          ></i>
        </div>
        <span class="team-count">{{ teamitem.ApplicationCount }}</span>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="ViewProcessDetail"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h5 class="modal-title">
          {{ selectedProcess?.ProcessName }} - Details
        </h5>
        <button
          type="button"
          (click)="onCloseProcessDetail()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <div class="formborder col-md-12"> -->
        <div class="col-md-3 float-right mb-2" [hidden]="!dataProcessSource">
          <form action="" class="search-text">
            <div class="bg-light rounded rounded-pill shadow-sm">
              <div class="input-group">
                <input
                  type="text"
                  id="FilterInputSearch"
                  (keyup)="applyFilter($event.target.value)"
                  name="FilterInputSearch"
                  placeholder="What're you searching for?"
                  class="form-control border-0 bg-light"
                />
                <div class="input-group-append">
                  <button
                    id="button-addon1"
                    type="submit"
                    class="btn btn-link text-primary"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- </div> -->

        <div class="table-responsive">
          <mat-table
            [dataSource]="dataProcessSource"
            matSort
            matTableExporter
            #processExporter="matTableExporter"
            style="height: 400px; max-width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="#">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                style="max-width: 50px"
                >#</mat-header-cell
              >
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell mw50"
              >
                {{
                  processPaginator.pageIndex * processPaginator.pageSize +
                    (i + 1)
                }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Application_No">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Application No</mat-header-cell
              >
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                <app-main-card-info [loanId]="row.Loan_Id" [index]="i">
                  {{ row.Application_No }}
                </app-main-card-info>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LoanAcNo">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >LoanAcNo</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.LoanAcNo }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Customer_Name">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                style="max-width: 150px"
                *matHeaderCellDef
                >Customer_Name
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                class="grid-cell"
                style="max-width: 150px"
              >
                <div>
                  {{ row.Customer_Name }}
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="BranchName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Branch</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.BranchName }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ProductName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Product</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ProductName }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Sourced_On">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Sourced_On</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Sourced_On }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Sourced_By">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Sourced_By</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Sourced_By }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="EmployeeName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                EmployeeName</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.EmployeeName }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Completed_ON">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                Completed_ON
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Completed_ON }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Current_Process">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Current_Process</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Current_Process }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Loan_Status">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Loan_Status</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Loan_Status }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="PendingSince">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >PendingSince</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.PendingSince }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Proposed_loanAmount">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Proposed_loanAmount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Proposed_loanAmount }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Approved_loanAmount">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Approved_loanAmount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Approved_loanAmount }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="TAT">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >TAT</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                <i
                  (click)="GoToTATReportDetail(row)"
                  class="fa fa-stopwatch"
                  aria-hidden="true"
                ></i>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedProcessColumns; sticky: true"
            ></mat-header-row>
            <mat-row
              (click)="highlightRow(row)"
              [class.highlight]="row.Application_No == selectedId"
              *matRowDef="let row; columns: displayedProcessColumns"
            ></mat-row>
          </mat-table>
          <div class="row m-0 align-items-center" style="background: #fff">
            <div class="col-md-4 p-1 pb-2 pt-2">
              <button
                class="btn font-size-12 button-btn"
                (click)="
                  exportDetailTable(processExporter, selectedProcess, 'Process')
                "
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Export
              </button>
            </div>
            <div class="col-md-8">
              <mat-paginator
                #processPaginator
                [length]="dataProcessSource?.data.length"
                [pageSize]="15"
                showFirstLastButtons
                [pageSizeOptions]="[15, 20, 50]"
              >
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade in"
  id="ViewTeamDetail"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h5 class="modal-title">{{ selectedTeam?.EmployeeName }} - Details</h5>
        <button
          type="button"
          (click)="onCloseTeamDetail()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <!-- <div class="formborder col-md-12"> -->
        <div class="col-md-3 float-right mb-2" [hidden]="!dataTeamSource">
          <form action="" class="search-text">
            <div class="bg-light rounded rounded-pill shadow-sm">
              <div class="input-group">
                <input
                  type="text"
                  id="FilterInputSearch"
                  (keyup)="applyFilter($event.target.value)"
                  name="FilterInputSearch"
                  placeholder="What're you searching for?"
                  class="form-control border-0 bg-light"
                />
                <div class="input-group-append">
                  <button
                    id="button-addon1"
                    type="submit"
                    class="btn btn-link text-primary"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- </div> -->

        <div class="table-responsive">
          <mat-table
            [dataSource]="dataTeamSource"
            matSort
            matTableExporter
            #teamExporter="matTableExporter"
            style="height: 400px; max-width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="#">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                style="max-width: 50px"
                >#</mat-header-cell
              >
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell mw50"
              >
                {{ teamPaginator.pageIndex * teamPaginator.pageSize + (i + 1) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Application_No">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Application No</mat-header-cell
              >
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                <app-main-card-info [loanId]="row.Loan_Id" [index]="i">
                  {{ row.Application_No }}
                </app-main-card-info>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LoanAcNo">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >LoanAcNo</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.LoanAcNo }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Customer_Name">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                style="max-width: 150px"
                *matHeaderCellDef
                >Customer_Name
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                class="grid-cell"
                style="max-width: 150px"
              >
                <div>
                  {{ row.Customer_Name }}
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="BranchName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Branch</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.BranchName }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ProductName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Product</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ProductName }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Sourced_On">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Sourced_On</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Sourced_On }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Sourced_By">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Sourced_By</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Sourced_By }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="EmployeeName">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                EmployeeName</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.EmployeeName }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Completed_ON">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                Completed_ON
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Completed_ON }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Current_Process">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Current_Process</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Current_Process }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Loan_Status">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Loan_Status</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Loan_Status }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="PendingSince">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >PendingSince</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.PendingSince }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Proposed_loanAmount">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Proposed_loanAmount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Proposed_loanAmount }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Approved_loanAmount">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >Approved_loanAmount</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Approved_loanAmount }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="TAT">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
                >TAT</mat-header-cell
              >
              <mat-cell *matCellDef="let row" class="grid-cell">
                <i
                  (click)="GoToTATReportDetail(row)"
                  class="fa fa-stopwatch"
                  aria-hidden="true"
                ></i>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedTeamColumns; sticky: true"
            ></mat-header-row>
            <mat-row
              (click)="highlightRow(row)"
              [class.highlight]="row.Application_No == selectedId"
              *matRowDef="let row; columns: displayedTeamColumns"
            ></mat-row>
          </mat-table>
          <div class="row m-0 align-items-center" style="background: #fff">
            <div class="col-md-4 p-1 pb-2 pt-2">
              <button
                class="btn font-size-12 button-btn"
                (click)="exportDetailTable(teamExporter, selectedTeam, 'Team')"
              >
                <i
                  class="fa fa-file-export mr-1"
                  style="font-size: medium; cursor: pointer"
                ></i>
                Export
              </button>
            </div>
            <div class="col-md-8">
              <mat-paginator
                #teamPaginator
                [length]="dataTeamSource?.data.length"
                [pageSize]="15"
                showFirstLastButtons
                [pageSizeOptions]="[15, 50]"
              >
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- View TAT Report Modal Sheet-->
<div
  class="modal fade in"
  id="ViewTATReportModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div
    class="modal-dialog modal-xl modal-dialog-centered wide-modal"
    role="document"
  >
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          View Details
        </h6>
        <button
          type="button"
          (click)="onCloseTATReportModel()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <table>
          <tbody>
            <tr>
              <td>
                <div><strong>Application No:</strong></div>
                {{ Application_No }}
              </td>
              <td>
                <div><strong>Customer:</strong></div>
                <div *ngIf="CustomerInfo == ''">&nbsp;</div>
                {{ CustomerInfo }}
              </td>
              <td>
                <div><strong>Product:</strong></div>
                {{ Product }}
              </td>
              <td>
                <div><strong>Branch:</strong></div>
                {{ Branch }}
              </td>
              <td>
                <div><strong>Loan Amount:</strong></div>
                ₹ {{ LoanAmount }}
              </td>
              <td>
                <div><strong>Loan Duration(Month):</strong></div>
                {{ LoanDuration_Month }}
                {{ LoanDuration_Month != "" ? "Months" : "" }}
              </td>
              <td>
                <div><strong>Created On:</strong></div>
                {{ ApplicationCreatedOn }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="table-responsive mt-3 mb-10"
          *ngIf="dataSourceDetail.data.length > 0"
        >
          <mat-table
            #TATTable
            [dataSource]="dataSourceDetail"
            matSort
            style="max-width: 100%; overflow: auto"
          >
            <ng-container matColumnDef="ProcessId">
              <mat-header-cell
                mat-sort-header
                class="grid-header table-head"
                style="max-width: 50px; min-width: 50px; width: 50px"
                *matHeaderCellDef
              >
                #
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row; let i = index"
                class="grid-cell"
                style="max-width: 50px; min-width: 50px; width: 50px"
              >
                {{ i + 1 }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Process">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                Process
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Process }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ProcessExecutive">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                Executive
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ProcessExecutive }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ProcessStatus">
              <mat-header-cell
                mat-sort-header
                class="grid-header table-head text-center"
                *matHeaderCellDef
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                Status
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell text-center">
                <span
                  *ngIf="row.ProcessStatus === 'Pending'"
                  class="status-badge pending"
                  >Pending</span
                >
                <span
                  *ngIf="row.ProcessStatus === 'Sendback'"
                  class="status-badge Sendback"
                  >Sendback</span
                >
                <span
                  *ngIf="row.ProcessStatus === 'Reverted'"
                  class="status-badge reverted"
                  >Reverted</span
                >
                <span
                  *ngIf="
                    row.ProcessStatus !== 'Pending' &&
                    row.ProcessStatus !== 'Reverted' &&
                    row.ProcessStatus !== 'Sendback'
                  "
                >
                  {{ row.ProcessStatus }}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="AssignedOn">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                Assign On
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.AssignedOn }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="CompletedOn">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                Completed On
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.CompletedOn }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="TAT_Hr">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                TAT (Hrs)
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.TAT_Hr }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Maximum_Standard_Tat">
              <mat-header-cell
                mat-sort-header
                class="grid-header table-head"
                *matHeaderCellDef
              >
                Max TAT (Hrs)
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Maximum_Standard_Tat }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="TAT_Status">
              <mat-header-cell
                mat-sort-header
                class="grid-header table-head"
                *matHeaderCellDef
              >
                TAT Status
              </mat-header-cell>
              <mat-cell
                *matCellDef="let row"
                class="grid-cell"
                [ngStyle]="{
                  color:
                    row.TAT_Status &&
                    row.TAT_Status.toLowerCase().includes('delayed')
                      ? 'red'
                      : ''
                }"
              >
                {{ row.TAT_Status }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Remark">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                Remark
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Remark }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="LatLong">
              <mat-header-cell
                mat-sort-header
                class="grid-header"
                *matHeaderCellDef
              >
                LatLong
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                <a
                  target="_blank"
                  *ngIf="
                    row.LatLong != '' &&
                    row.LatLong != null &&
                    row.LatLong != ','
                  "
                  [href]="'http://maps.google.com/maps?q=' + row.LatLong"
                >
                  <i class="fa-solid fa-location-dot"></i>
                </a>
              </mat-cell>
            </ng-container>
            <mat-header-row
              *matHeaderRowDef="displayedDetailColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let row; columns: displayedDetailColumns"
            ></mat-row>
          </mat-table>
          <!-- <mat-paginator #paginatorRef [pageSizeOptions]="[50]" showFirstLastButtons> </mat-paginator> -->
        </div>
        <hr />
        <table style="text-align: center">
          <tbody>
            <tr>
              <td
                style="border-right: 2px solid white"
                class="time-content"
                [ngClass]="{ 'delayedTime-content': isProcessDelayed() }"
              >
                <div>
                  <strong>
                    Process Completion Time Before Current Process :
                    {{ ProcessComplition }} /
                    {{ getTotalMaximumStandardTatFormatted() }}
                  </strong>
                </div>
              </td>
              <td
                class="time-content"
                [ngClass]="{ 'delayedTime-content': isPendingDelayed() }"
              >
                <div>
                  <strong>
                    Pending On Current Process: {{ PendingSince }} /
                    {{ getPendingMaximumStandardTatFormatted() }}
                  </strong>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
